import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable()
export class UserService {

  httpOptions = {
      headers: new HttpHeaders({'Content-Type':'application/json'})
  };

  constructor(private http:HttpClient) { }

  getUsers(){
      return this.http.get('/users');
  }

  getUsersWithRole(role:string){
    let config = {
        headers: new HttpHeaders({'Content-Type':'application/json'})
      };
      
    config["params"] = {
        q:role
    }

    return this.http.get('/users/userWithRole', config);
}

  getUser(id){
      return this.http.get('/users/' + id);
  }

  createUser(data) {
      let body = JSON.stringify(data);
      return this.http.post('/users/', body, this.httpOptions);
  }

  updateUser(data) {
      let body = JSON.stringify(data);
      return this.http.put('/users/' + data.id, body, this.httpOptions);
  }

  deleteUser(data) {
      return this.http.delete('/users/' + data.id);
  }

  deleteAttachment(data, type){
      return this.http.get('/users/' + data.id + '/delete/' + type);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/users/user.service.ts